'use strict';

/* global $ */

import { breakpoints } from 'settings'

function JuxtaPose (options) {
    let opt = $.extend({
        selector: '.js-juxtapose',
    }, options);

    let slider = new juxtapose.JXSlider(opt.selector,
        [
            {
                src: $(opt.selector).data('src_before'),
                //label: '2009',
                //credit: 'Image Credit'
            },
            {
                src: $(opt.selector).data('src_after'),
                //label: '2014',
                //credit: "Image Credit"
            }
        ],
        {
            animate: true,
            showLabels: true,
            showCredits: true,
            startingPosition: "50%",
            makeResponsive: true
        }
    );
}


export {
    JuxtaPose
};